import {
  reactQueryDelete,
  reactQueryPost,
  reactQueryPut,
} from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";
import type { MarketingEmailTemplateParams } from "../types/MarketingEmailTemplates";
import type {
  MarketingEmailTemplateDetailURLParams,
  UpdateMarketingEmailTemplateParams,
  UpdateResponseData,
} from "./marketingEmailTemplateApi";

const create = (body: MarketingEmailTemplateParams) =>
  reactQueryPost(internalApi.systemMarketingEmailTemplates.index(), body);

const update = ({ id, body }: UpdateMarketingEmailTemplateParams) =>
  reactQueryPut<UpdateResponseData, MarketingEmailTemplateParams>(
    internalApi.systemMarketingEmailTemplates.item({ id }),
    body,
  );

const deleteTemplate = ({ id }: MarketingEmailTemplateDetailURLParams) =>
  reactQueryDelete(internalApi.systemMarketingEmailTemplates.item({ id }));

export const systemMarketingEmailTemplatesApi = {
  create,
  update,
  deleteTemplate,
};
